import { render, staticRenderFns } from "./ShouFeiBiaoZhunView.vue?vue&type=template&id=e8be3bfe&scoped=true"
import script from "./ShouFeiBiaoZhunView.vue?vue&type=script&lang=js"
export * from "./ShouFeiBiaoZhunView.vue?vue&type=script&lang=js"
import style0 from "./ShouFeiBiaoZhunView.vue?vue&type=style&index=0&id=e8be3bfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8be3bfe",
  null
  
)

export default component.exports